import { capitalize } from 'utils/capitalize.ts';

const ROUTE_PARAM_PREFIX = 'routeParam';
const QUERY_PARAM_PREFIX = 'queryParam';

function splitCategorySeoName(categorySeoName: string) {
	const index = categorySeoName?.indexOf('-');

	return {
		[ROUTE_PARAM_PREFIX + 'CategoryId']: categorySeoName?.slice(0, index) ?? undefined,
		[QUERY_PARAM_PREFIX + 'CategoryName']: categorySeoName?.slice(index + 1) ?? undefined,
	};
}

export const SEARCHPAGE_PATH_PARAMS = [splitCategorySeoName, 'locality', 'price', 'sort', 'page'];
export const BAZAR_PATH_PARAMS = [null, 'shopSeo', 'sort', 'page'];
export const DETAIL_OFFER_PATH_PARAMS = [null, 'advertSeo'];

export function getSearchPageUrlParams() {
	return getRouteParams(SEARCHPAGE_PATH_PARAMS);
}

export function getBazarUrlParams() {
	return getRouteParams(BAZAR_PATH_PARAMS);
}

export function getOfferDetailUrlParams() {
	return getRouteParams(DETAIL_OFFER_PATH_PARAMS);
}

export function getUnpackedOfferDetailUrlParams() {
	return getRouteParams(DETAIL_OFFER_PATH_PARAMS);
}

export function getRouteParams(
	definitions: (string | ((pathSegment: string) => Record<string, string | undefined>) | null)[],
) {
	const params: Record<string, string> = {};
	globalThis.window.location.pathname
		.split('/')
		.slice(1)
		.forEach((part, index) => {
			const definition = definitions[index];

			if (definition) {
				if (typeof definition === 'function') {
					Object.assign(params, definition(part));
				} else {
					params[ROUTE_PARAM_PREFIX + capitalize(definition)] = part;
				}
			}
		});

	for (const [key, value] of new URLSearchParams(globalThis.window.location.search)) {
		params[QUERY_PARAM_PREFIX + capitalize(key)] = value;
	}

	return params;
}
